import { styled } from "src/styles/stitches/theme";

export const StyledNotification = styled("div", {
  display: "flex",
  alignItems: "center",
});
